import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray } from 'redux-form';

import { Typography } from '@material-ui/core';

import { CheckboxButtonsGroup, TimeDuration } from 'components';

import { useStyles } from './styles';

const ScheduleDaysTimeDuration = ({ field, disabledDays }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.wrapper}>
      <Field
        name={`${field}.days`}
        title="Select Days *"
        disabledDays={disabledDays}
        component={CheckboxButtonsGroup}
      />
      <div className={classes.divider}>{''}</div>
      <Typography className={classes.title} variant="body1">
        {t('Start time & Duration')}
      </Typography>
      <FieldArray
        name={`${field}.startTimeAndDuration`}
        disabledItemIndex={0}
        component={TimeDuration}
      />
    </div>
  );
};

export default ScheduleDaysTimeDuration;
